jQuery(document).ready(function($){
    
    $('#slides').after('<div id="slidenav"></div>');
    $('#slides').cycle({
	    fx:     'fade',
        timeout: 7000,
        speed: 1500,
        pager:  '#slidenav'
	});
	    
    $("a[rel='lightbox']").colorbox({transition:"elastic"});
    $('.go-back a').click(function() {
        javascript:history.back();
        return false;
    });

    style = 'easeOutQuart';
    $('#product-collection li').hover(  
        function() {  
            //show
            $(this).children('div:first').stop(false,true).animate({bottom:1,left:1},{duration:500, easing: style});  
        },  
        function() {  
            //hide
            $(this).children('div:first').stop(false,true).animate({bottom:-70, left:-191},{duration:500, easing: style});  
        }  
    );

    $('#navigation li.has-menu').hover(  
        function() {  
            $(this).addClass('menu-active');  
        },  
        function() {  
            $(this).removeClass('menu-active');  
        }  
    );

    $('#search-input').click(function() {
        $(this).val('');
    });

	$('#sidebar-accordion').accordion({
    	header: 'h3',
    	selectedClass: 'selected',
    	navigation: true,
    	autoHeight: false,
    	active: '.selected',
        animated: 'bounceslide',
    	alwaysOpen: false
	});

	$("#sidebar-accordion ul.animated a").hover(function(){
		$(this).stop().animate({ paddingLeft: "20px" }, 'fast');
	}, function(){
		$(this).stop().animate({ paddingLeft: "10px" }, 'fast');
	});
});